<template>
<div class="text-sm-left">
    <v-dialog
      v-model="dialog"
      width="1500"
      persistent
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="primary"
          dark
          v-on="on"
          @click="cargarData"
        >
          Insertar/eliminar procesos peligrosos
        </v-btn>
      </template>
      <v-card>
    <v-card-title class="grey lighten-3">
      Procesos peligrosos
    </v-card-title>
    <v-sheet class="pa-3 primary lighten-2">
      <v-text-field
        v-model="search"
        label="Buscar en diagnósticos"
        dark
        flat
        solo-inverted
        hide-details
        clearable
        clear-icon="mdi-close-circle-outline"
      ></v-text-field>    
    </v-sheet>
    <v-layout
      justify-space-between
      pa-3
    >
      <v-flex xs5>
        <v-treeview
          :active.sync="active"
          :items="items"
          :load-children="getProcesosPeligrososChildren"
          :open.sync="open"
          activatable
          active-class="primary--text"
          class="grey lighten-5"
          open-on-click
          transition
          :filter="filter"    
          :search="search"
        >
          <template v-slot:prepend="{ item, active }">
            <v-icon
              v-if="!item.children"
              :color="active ? 'primary' : ''"
            >
              mdi-account
            </v-icon>
          </template>
        </v-treeview>
      </v-flex>

      <v-divider vertical></v-divider>

      <v-flex
        xs12
        md6
      >
        <v-card-text>
          <div
            v-if="this.selections.length === 0"
            key="title"
            class="title font-weight-light grey--text pa-3 text-xs-center"
          >
            Seleccione procesos peligrosos
          </div>

                    <v-list>


          <v-list-tile
            v-for="item in this.selections"
            :key="item.id"            
            dense            
          >

            <v-list-tile-content>
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon ripple @click="deleteItem(item)">
                <v-icon color="grey lighten-1">delete</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>

        
        </v-list>

        </v-card-text>
      </v-flex>
    </v-layout>

    <v-divider></v-divider>

    <v-card-actions>
      <v-btn
        flat
        @click="dialog = false"
        color="accent"
      >
        Cancelar
      </v-btn>
      <v-btn
        flat
        @click="clearSelections"
      >
        Seleccionar de nuevo
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn
        class="white--text"
        color="primary"
        depressed
        @click="agregarSeleccion"
      >Aceptar        
      </v-btn>
    </v-card-actions>
  </v-card>

    </v-dialog>
</div>
</template>

<script>

  const pause = ms => new Promise(resolve => setTimeout(resolve, ms))

  export default {
    props: {
      listaProcesosPeligrososPadre : {
        required : true,
        type : Array
      }
    },
    data: () => ({
      active: [],
      avatar: null,
      open: [],
      procesosPeligrosos: [],
      dialog: false,    
      procesosPeligrososAux: [],
      selections: [],
      search: null,
      listaProcesosPeligrososPadreAux: []
    }),

    computed: {
      filter () {
        return this.caseSensitive
          ? (item, search, textKey) => item[textKey].indexOf(search) > -1
          : undefined
      },
      items () {
        return this.procesosPeligrosos;
      }
    },

    watch: {
      active (val) {
        if (this.selections.find(procesoPeligroso => procesoPeligroso.id === val[0]) != null) {
          return;
        }
        var newItem = this.getProcesoPeligroso(val[0]);
        if (newItem !== undefined) {          
          this.selections.push(newItem);
        }
      }
    },

    methods: {
      getProcesosPeligrososParents() {           
        this.$store.dispatch('findCatalogByTypeResolve', 'procPeligrosos1ernivel').then(response => {                    
          for (let i=0;i<response.length;i++) {
            this.procesosPeligrososAux.push({id:response[i].id, 
                                    name:response[i].name,
                                    children:[]});
            this.procesosPeligrosos.push({id:response[i].id, 
                                    name:response[i].name,
                                    children:[]});            
          }
        }, error => {
          this.$store.state.dialogError = true;
        })                
      },
      async getProcesosPeligrososChildren(parent) {
        if (typeof(parent) === 'object') {
          await pause(500);                      
          this.$store.dispatch('findCatalogChildrenResolve', parent.id).then(response => {                      
            for (let i=0;i<response.length;i++) {          
                var procesoPeligroso = {};
                procesoPeligroso.id = response[i].id;
                procesoPeligroso.name = response[i].name;
                procesoPeligroso.parentName = parent.name;           
                this.procesosPeligrososAux.push(procesoPeligroso);
                parent.children.push(procesoPeligroso);
              }                     
          }, error => {
            this.$store.state.dialogError = true;
          })
          await pause(500); 
        }            
      },          
      getProcesoPeligroso (id) {       
        return this.procesosPeligrososAux.find(procesoPeligroso => procesoPeligroso.id === id);
      },
      clearSelections () {
        this.selections = [];
        this.open = [];
        this.active = [];
      },
      deleteItem(item) {
        this.active = [];
        var index = this.selections.indexOf(item);
        this.selections.splice(index, 1);
      },
      agregarSeleccion() {
        this.$emit('clicked', this.selections);
        this.dialog = false;
      },
      getListaProcesosPeligrososPadre() {
        this.listaProcesosPeligrososPadreAux = this.listaProcesosPeligrososPadre;
        return this.listaProcesosPeligrososPadreAux;
      },
      cargarData() {
        this.active = [];
        this.open = [];        
        this.selections = this.getListaProcesosPeligrososPadre();        
      }
    },
    created : function() {
      this.getProcesosPeligrososParents();      
    }
  }
</script>
<style scoped>
  .v-treeview-node__label{
    font-size: 12px;
  }
</style>


// WEBPACK FOOTER //
// src/components/patient/procesosPeligrosos/ProcesosPeligrosos.vue